import { buttonClickEvent } from '@dashboard/junk-drawer/utils/eventstream';

// NB: These tracking events were extracted from the dashboard app, and are hard-coded assuming they are used for sales reports
export function superTableAddColumn(column) {
  return buttonClickEvent('Sales Reports Custom Columns: Add Column', {
    page_click_detail: column
  });
}
export function superTableRemoveColumn(column) {
  return buttonClickEvent('Sales Reports Custom Columns: Remove Column', {
    page_click_detail: column
  });
}